import React from 'react'
import "../MensData.js/ProductsJeansPant.css";
import jeans1 from "../assets/jeans.jpg"
export default function ProductsJeansPant() {

    const productsJeansPant = [
  {
    id: 1,
    name: "Model No.MG-25725-14",
    description: "Premium , Modern fit",
    image: jeans1,
    link: "/products/men-Jeans-&-Pants1",
  },
  
 
];
  return (
    <>
       <section className="pgp">
      <h1 style={{textAlign:"center",fontSize:"42px"}}>Men Jeans & Pants</h1>
      <div className="pgp__grid">
        {productsJeansPant.map((p) => (
          <article key={p.id} className="psl__card">
            <img className="pgp__image" src={p.image} alt={p.name} loading="lazy" />
            <h3 className="pgp__name">{p.name}</h3>
            <p className="pgp__desc">{p.description}</p>
            <a className="pgp__btn" href={p.link} aria-label={`View ${p.name}`}>
             Explore More
            </a>
          </article>
        ))}
      </div>
    </section>

    </>
  )
}
